import {
  CompanyContextCategory,
  ContextQuestion,
  usePickCompanyCategoryMessageQuery
} from 'generated/graphql';

import { useMemo } from 'react';



type IQuestionOrGlAccountType = Pick<ContextQuestion, 'id' | 'content' | 'glAccountTypeName'> & Pick<CompanyContextCategory, 'name'> & {
  type: 'contextQuestion' | 'glAccount';
};

export interface IData {
  categories: Pick<CompanyContextCategory, 'name' | 'displayName'>[];
  questions: Array<IQuestionOrGlAccountType>;
}

export function useQuery(listedCompanyId: string) {
  const tuple = usePickCompanyCategoryMessageQuery({
    variables: {
      listedCompanyId
    }
  });

  return useMemo(
    () => {
      const glAccounts = tuple.data?.standardGlAccounts
        .filter((gl) => gl.contextCategory)
        .map((glAccount): IQuestionOrGlAccountType => ({
          type: 'glAccount',
          id: glAccount.id,
          content: glAccount.chatDisplayName,
          // This will always have a value because of the filter above.
          name: glAccount.contextCategory ?? 'guidance',
          glAccountTypeName: glAccount.name
        })) ?? [];

      const setOfGlAccounts = new Set(glAccounts.map((gl) => gl.glAccountTypeName));

      const contextQuestions = tuple.data?.contextQuestions
        .filter((question) => !setOfGlAccounts.has(question.glAccountTypeName))
        .map((question): IQuestionOrGlAccountType => ({
          type: 'contextQuestion',
          id: question.id,
          content: question.content,
          name: question.category.name,
          glAccountTypeName: question.glAccountTypeName ?? ''
        })) ?? [];

      const data: IData = {
        categories: tuple.data?.companyContextCategories.map((c) => ({
          name: c.name,
          displayName: c.displayName
        })) ?? [],
        questions: [
          ...glAccounts,
          ...contextQuestions
        ]
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
